import { render, staticRenderFns } from "./TrainingComments.vue?vue&type=template&id=152ee05d&scoped=true"
import script from "./TrainingComments.vue?vue&type=script&lang=js"
export * from "./TrainingComments.vue?vue&type=script&lang=js"
import style0 from "./TrainingComments.vue?vue&type=style&index=0&id=152ee05d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ee05d",
  null
  
)

export default component.exports